export class Logo {
    name?: string;
    format?: string;
    content?: string;
}